import { DotChartOutlined } from '@ant-design/icons';
import { Col, Row, Space, Statistic } from 'antd';

import { Card } from '@/components/atoms';

const AdminUsersListOverview = ({ total }) => (
    <Row gutter={[0, 32]}>
        <Col span={24}>
            <Card
                styles={{ body: { display: 'none' } }}
                extra={<Statistic title="Total" value={total} />}
                title={
                    <Space>
                        <DotChartOutlined /> Overview (V2 Deployed 22nd October 2020)
                    </Space>
                }
            />
        </Col>
    </Row>
);

export { AdminUsersListOverview };
